import { createFileRoute } from "@tanstack/react-router";
import { ClientDetailBody } from "@/components/crm/ClientDetailView";

export const Route = createFileRoute("/crm/$clientId")({
  component: ClientDetailRoute,
});

function ClientDetailRoute() {
  const { clientId } = Route.useParams();
  return <ClientDetailBody clientId={clientId} />;
}
